import { useEffect, useState } from 'react';

const SingleSelect = (props) => {
  let { label, data, displayValue, style, value, defaultOption } = props;
  const [selectedValue, setSelectedValue] = useState(-99);
  const [click, set_click] = useState(false);

  useEffect(() => {
    if (data && data.length > 0 && !defaultOption) {
      value(data[0]);
      setSelectedValue(-99);
    }
  }, [data]);

  return (
    <div className={`${style}`}>
      {label && (
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          {label}
        </label>
      )}

      <select
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        onChange={(e) => {
          set_click(true);
          if (e.target.value === '-99') {
            setSelectedValue(-99);
            return value(null);
          }
          const selectedOption = JSON.parse(e.target.value);
          value(selectedOption);
          setSelectedValue(e.target.value);
        }}
        value={selectedValue}
        // defaultValue={JSON.stringify(data[0])}
      >
        {defaultOption && click == false ? <option value="-99">{defaultOption}</option> : null}
        {data?.map((item, index) => {
          return (
            <option key={index} value={JSON.stringify(item)}>
              {item[displayValue]}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default SingleSelect;
